var map = {
	"./gallery-wip-electronics_00.jpg": 4257,
	"./gallery-wip-electronics_01.jpg": 4258,
	"./gallery-wip-electronics_02.jpg": 4259,
	"./gallery_00.jpg": 4260,
	"./gallery_01.jpg": 4261,
	"./gallery_02.jpg": 4262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4256;